import {
    ACCOUNT_PURGE_ACCOUNT_OPEN_MODAL,
    ACCOUNT_PURGE_ACCOUNT_CLOSE_MODAL,
    ACCOUNT_PURGE_ACCOUNT_REQUEST,
    ACCOUNT_PURGE_ACCOUNT_RESULT
} from "Redux/actionTypes";

export const accountPurgeAccountOpenModal = (data) => ({
    type: ACCOUNT_PURGE_ACCOUNT_OPEN_MODAL,
    payload: data
})

export const accountPurgeAccountCloseModal = () => ({
    type: ACCOUNT_PURGE_ACCOUNT_CLOSE_MODAL
})

export const accountPurgeAccountRequest = (id) => ({
    type: ACCOUNT_PURGE_ACCOUNT_REQUEST,
    payload: id
})

export const accountPurgeAccountResult = (result) => ({
    type: ACCOUNT_PURGE_ACCOUNT_RESULT,
    payload: result
})